import React, {useRef, useState} from "react";
import {t, Trans} from '@lingui/macro';
import {Col, Input, Modal, Row} from "antd";
// import { Scrollbars } from 'react-custom-scrollbars';
import styled, {css} from 'styled-components';
import {ExpandAltOutlined, ShrinkOutlined} from "@ant-design/icons";
import BukkuTooltip from "../Tooltip";

export const TextAreaExpandIconCSS = css`
  .text-area-helper-icon {
    position: absolute;
    right: 4.5px;
    bottom: 3px;

    /* display: flex; */
    /* flex-direction: column; */
    /* justify-content: flex-end; */
    /* margin-bottom: 3px; */

    align-items: center;
    font-size: 14.5px;
    color: rgba(0, 0, 0, 25%);

    .icon--expand {
      transition: color 0.2s ease;

      &:hover {
        color: #1890ff;
      }
    }
  }
`;

const Styled = styled.div`
  position: relative;

  textarea.ant-input {
    padding-right: 16px !important;
  }

  /* SCROLLBAR - Works on Firefox - but cannot define custom width */
  textarea {
    scrollbar-width: thin;
    scrollbar-color: rgba(0,0,0,20%);
  }

  /* SCROLLBAR - Works on Chrome, Edge, and Safari */
  textarea::-webkit-scrollbar {
    width: 3px;
  }

  textarea::-webkit-scrollbar-track {
    background: none;
  }

  textarea::-webkit-scrollbar-thumb {
    border-radius: 30px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 30%);

    &:hover, &:active {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 60%);
    }
  }

  ${TextAreaExpandIconCSS}
`;

const StyledModal = styled(Modal)`

  .ant-modal-content {
    padding: 0;
    border-radius: 6px;

    .ant-modal-body {
      padding: 0;

      .row--top {
        display: flex;
        justify-content: space-between;

        .text--title {
          padding-top: 10px;
          padding-bottom: 2px;
          padding-left: 18px;
          font-size: 16px;
          font-weight: 900;
        }

        .icon--shrink {
          padding: 12px;
          font-size: 18px;
          opacity: 0.6;
          transition: color 0.2s ease;
          transition-property: color, opacity;

          &:hover {
            color: #1890ff;
            opacity: 1;
          }
        }
      }

      hr {
        margin: 0;
        opacity: 0.3;
      }

      .row--bottom {
        padding-bottom: 10px;

        textarea {
          padding: 10px 20px;
          border: 0;
          border-radius: 8px;
          box-shadow: none;
        }
      }
    }

    .ant-modal-close {
      top: 10px;
    }
  }
`;

export function TextArea(props) {
    const inputRef = React.useRef(null);

    const divRef = useRef(null);
    const [isModalVisible, setModalVisible] = useState(false);
    const { textAreaRef, minRows, maxRows, ...restProps } = props;

    const focusRef = ref => {
        setTimeout(() => {
            ref.current.focus({
                cursor: 'end',
            });
        }, 300); // add some delay so the ref is correct after changing modalVisible
    };

    const onModalCancel = () => {
        setModalVisible(false); // small textarea
        focusRef(textAreaRef || inputRef);
    };

    const openLargeTextArea = () => {
        setModalVisible(true); // modal textarea
        focusRef(inputRef);
    };

    return (
        <Styled
            ref={divRef}
            onClick={e => e.stopPropagation()}
        >
            <Row>
                <Col span={24}>
                    <Input.TextArea
                        {...restProps}
                        // to account for those without textAreaRef
                        // (eg: FormItem when there are description and subtitle)
                        ref={textAreaRef || inputRef}
                        autoSize={{ minRows: (minRows || 1), maxRows: (maxRows || 6) }}
                    />

                    <span className="text-area-helper-icon">
                        <BukkuTooltip title={t`Expand description field view`}>
                            <ExpandAltOutlined className="icon--expand" onClick={openLargeTextArea} />
                        </BukkuTooltip>
                    </span>
                </Col>
            </Row>

            <StyledModal
                open={isModalVisible}
                centered
                onCancel={onModalCancel}
                closeIcon={<ShrinkOutlined className="icon--shrink" />}
                footer={null}
            >
                <Row className="row--top">
                    <span className="text--title"><Trans>Description</Trans></span>

                </Row>
                <hr />
                <Row className="row--bottom">
                    <Input.TextArea
                        ref={inputRef}
                        autoSize={{ minRows: 10, maxRows: (maxRows || 15) }}
                        {...restProps}
                    />
                </Row>
            </StyledModal>
        </Styled>
    );
}
